var render = function () {
  var _vm$giftee, _vm$giftee$phone, _vm$giftee$phone$phon;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "720"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.mode == 'form' ? [_c('v-card', {
    staticClass: "v-card--dialog"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("선물하기")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('v-sheet', {
    staticClass: "mx-auto pa-3",
    attrs: {
      "max-width": "344"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "page-text font-weight-bold"
  }, [_vm._v("교환금액")]), _c('v-text-field', {
    staticClass: "mt-1 text-right",
    attrs: {
      "value": _vm.amount.format(),
      "outlined": "",
      "readonly": "",
      "hide-details": "",
      "suffix": "원"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "page-text font-weight-bold"
  }, [_vm._v("받는사람 번호")]), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "placeholder": "‘-’ 없이 번호만 기재",
      "hide-details": ""
    },
    model: {
      value: _vm.giftee.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.giftee, "phone", $$v);
      },
      expression: "giftee.phone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small primary--text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" * ")]), _c('v-col', {
    staticClass: "page-text page-text--small"
  }, [_vm._v(" 정확한 연락처를 확인 후 보내시기 바라며, "), _c('br'), _vm._v(" 번호 오기재로 인해 발생한 문제는 책임지지 않습니다. ")])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__foot d-flex justify-center"
  }, [_c('v-btn', {
    staticClass: "w-160px",
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'view';
      }
    }
  }, [_vm._v("핀 선물하기")])], 1)], 1)] : _vm._e(), _vm.mode == 'view' ? [_c('v-card', {
    staticClass: "v-card--dialog"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("입력하신 연락처로 " + _vm._s(_vm.amount.format()) + " 캐시를 보내시겠습니까?")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "v-card--dialog__body page-text"
  }, [_c('v-sheet', {
    staticClass: "mx-auto px-3 py-12",
    attrs: {
      "max-width": "344"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v(" 연락처 ")]), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_vm._v(" " + _vm._s((_vm$giftee = _vm.giftee) === null || _vm$giftee === void 0 ? void 0 : (_vm$giftee$phone = _vm$giftee.phone) === null || _vm$giftee$phone === void 0 ? void 0 : (_vm$giftee$phone$phon = _vm$giftee$phone.phoneNumberFormat) === null || _vm$giftee$phone$phon === void 0 ? void 0 : _vm$giftee$phone$phon.call(_vm$giftee$phone)) + " ")]), _c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v(" 보내는 금액 ")]), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_vm._v(" " + _vm._s(_vm.amount.format()) + " 원 ")])], 1)], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__foot "
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-row', {
    staticClass: "row--small primary--text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" * ")]), _c('v-col', {
    staticClass: "page-text page-text--small"
  }, [_vm._v(" 정확한 연락처를 확인 후 보내시기 바라며, "), _c('br'), _vm._v(" 번호 오기재로 인해 발생한 문제는 책임지지 않습니다. ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exec
    }
  }, [_vm._v("예")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'form';
      }
    }
  }, [_vm._v("아니오")])], 1)], 1)], 1)], 1)], 1)], 1)] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }